import React, { useEffect } from "react";
import Home from "./components/Home";
import { SitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { Route, Switch } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import componentFactory from "./temp/componentFactory";
import SitecoreContextFactory from "./lib/SitecoreContextFactory";
import RouteHandler from "./RouteHandler";
import {createBrowserHistory} from "history";

// This is the main JSX entry point of the app invoked by the renderer (server or client rendering).
// By default the app's normal rendering is delegated to <RouteHandler> that handles the loading of JSS route data.

// support languages in the URL prefix
// e.g. /da-DK/path, or /en/path, or /path
export const routePatterns = [
    "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*",
    "/:lang([a-z]{2})/:sitecoreRoute*",
    // "/:sitecoreRoute*",
];

const browserHistory = createBrowserHistory();

// wrap the app with:
// ApolloProvider: provides an instance of Apollo GraphQL client to the app to make Connected GraphQL queries.
//    Not needed if not using connected GraphQL.
// SitecoreContext: provides component resolution and context services via withSitecoreContext
// Router: provides a basic routing setup that will resolve Sitecore item routes and allow for language URL prefixes.
const AppRoot = ({ path, Router, graphQLClient }) => {
    // useEffect(() => {
    //   // window.location.href = "landing";
    //   browserHistory.push("/v4wem/brochureIndex.html");
    // }, []);

    const routeRenderFunction = (props) => <RouteHandler route={props} />;
    // const brochure = "<h1>Sample Site Outside</h1>";
    // console.log(Page)
    return (
        <ApolloProvider client={graphQLClient}>
            <SitecoreContext
                componentFactory={componentFactory}
                contextFactory={SitecoreContextFactory}
            >
                <Router location={path} context={{}}>
                    {/* <div dangerouslySetInnerHTML={{__html: brochure}} /> */}
                    <Switch>
                        <Route path="/utility" render={routeRenderFunction} />
                        {routePatterns.map((routePattern) => {
                            // console.log(routePattern);
                            return (
                                <Route
                                key={routePattern}
                                path={`${routePattern}`}
                                render={routeRenderFunction}
                                />
                            );
                        })}
                        <Route path="/" render={Home} />
                    </Switch>
                </Router>
            </SitecoreContext>
        </ApolloProvider>
    );
};

export default AppRoot;
